<template>
  <div class="containerr">
    <h2 class="section-title">查找離你最近的停車場</h2>

    <section class="parking-map">
      <div class="map-container">
        <div class="info-panel">
          <div class="logo">
            <img src="/TPicon.png" alt="Logo" />
          </div>
          <div class="number-section">
            <div class="number">483+</div>
            <div class="label">持續增建中</div>
          </div>
          <div class="buttons">
            <button class="more-btn btn-yellow" @click="goMap()">地圖查詢</button>
            <button class="more-btn btn-green" @click="goList()">清單查詢</button>
          </div>
        </div>
        <div class="maplet">
          <!-- Use the ParkingMaplet component here -->
          <ParkingMaplet />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ParkingMaplet from '@/components/home/ParkingMaplet.vue';

export default {
  name: 'ParkingMap',
  components: {
    ParkingMaplet,
  },
  methods: {
    goMap() {
      this.$router.push({ name: 'ParkingLots' });
    },
    goList() {
      this.$router.push({ name: 'ParkingLots' });
    },
  },
};
</script>

<style scoped>
.containerr {
  width: 100%;
}

.parking-map {
  max-width: 1600px;
  height: 580px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}

.map-container {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  /* border-radius: 0px; */
  border-radius: 20px;
  overflow: hidden;
}

.info-panel {
  /* flex: 1; */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 640px;
  /* gap: 1.5rem; */
  border-right: 1px solid #f1f1f1;
}

.logo {
  margin-top: 96px;
}

.logo img {
  width: 80px;
  height: 80px;
}

.number-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 4rem;
  color: var(--primary-green);
}

.number-section .number {

  font-family: Inter;
  font-size: 96px;
  font-weight: 900;
  line-height: 116.18px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  color: var(--green03);

  margin-top: 24px;

}

.label {
  /* //styleName: 2xl/bold; */
  font-family: Inter;
  font-size: 24px;
  font-weight: 700;
  line-height: 33.6px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  color: vart(--gray15);

  margin-top: 0px;

}

.buttons {
  display: flex;
  gap: 24px;

  margin-top: 61px;


}

.more-btn {
  padding: 16px 32px 16px 32px;
  border-radius: 99px;


  cursor: pointer;
  transition: background-color 0.3s, transform 0.3s;


  /* //styleName: lg/bold; */
  font-family: Inter;
  font-size: 18px;
  font-weight: 700;
  line-height: 26.1px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  margin-top: 0px;

}

.btn-yellow {
  background-color: var(--yellow03);
  color: var(--green03);
}

.btn-yellow:hover {
  background-color: var(--yellow02);
}

.btn-green {
  background-color: var(--green03);
  color: #fff;
}

.btn-green:hover {
  background-color: var(--green01);
}

.maplet {
  flex: 2;
  height: 100%;
  width: 100%;
  /* width: 960px; */

  border-radius: 0;
}

@media (max-width: 560px) {
  .page-title {
    margin-bottom: 32px;
  }

  .parking-map {
    width: 343px;
    height: 600px;
    flex-direction: column;
  }

  .map-container {
    flex-direction: column-reverse;
    justify-content: flex-end;
    padding-bottom: 20px;
  }

  .map {
    order: -1;
    width: 100%;
    height: 300px;
  }

  .info-panel {
    width: 100%;
    height: 280px;
    border-right: none;
    border-top: 1px solid #f1f1f1;
  }

  .logo {
    margin-top: 20px;
  }

  .logo img {
    width: 40px;
    height: 40px;
  }


  .number-section .number {
    font-family: Inter;
    font-size: 64px;
    font-weight: 900;
    line-height: 78.08px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    margin-top: 16px;
  }

  .label {
    /* //styleName: lg/bold; */
    font-family: Inter;
    font-size: 18px;
    font-weight: 700;
    line-height: 26.1px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

  }

  .buttons {
    margin-top: 24px;
    gap:20px;
  }

  .more-btn {
    padding: 10px 20px;


    /* //styleName: sm/bold; */
    font-family: Inter;
    font-size: 14px;
    font-weight: 700;
    line-height: 21.56px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;


  }


  .maplet {
    width: 343px;
    height: 300px;
  }
}
</style>
